import { useTranslation } from "react-i18next";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import { ACTIVITY_STATUS } from "shared/types/enums";

import { DeviceStatusIconProps } from "./types";

const DeviceStatusIcon = ({ status }: DeviceStatusIconProps) => {
    const { t } = useTranslation();

    const getBadgeData = (statusName: ACTIVITY_STATUS) => {
        switch (statusName) {
            case ACTIVITY_STATUS.Online:
                return { color: BadgeColors.success, isInverted: true };
            case ACTIVITY_STATUS.Offline:
                return { color: BadgeColors.neutral, isInverted: false };
            default:
                return { color: BadgeColors.light, isInverted: false };
        }
    };

    const color = getBadgeData(status).color;
    const isInverted = getBadgeData(status).isInverted;

    const name = t(`General##${status}`);

    return (
        <Badge color={color} inverted={isInverted}>
            {name}
        </Badge>
    );
};

export default DeviceStatusIcon;
